// extracted by mini-css-extract-plugin
module.exports = {"navLink":"NavigationLinks_navLink__lvJaL","navigation":"NavigationLinks_navigation__MrTog"};